import { Injectable } from '@angular/core';
import { LoginAuthUserInputFields } from '@com-delta-idp/mnx-login-ui';
import {
  BAU_REFRESH_URL,
  ENCRYPTED_FIELDS,
  REDIRECT_BACK,
  REFRESH_URL
} from '../constants/login-constant';
import {
  loginAndGetDashboardRequest,
  loginCustomerRequest
} from '../models/login-authentication-screen.interface';
import { encryptedFields } from '../models/login-customer.interface';
import { LoginContentAdapterSupportService } from './login-content-adapter-support.service';
@Injectable({
  providedIn: 'root'
})
export class LoginContentAdapterService extends LoginContentAdapterSupportService {
  getNewBrdDashDataRequest(
    userInputFields: LoginAuthUserInputFields | undefined,
    access_token: string,
    fromApp = '',
    standalonePage = false,
    tokenHeader: boolean
  ): loginAndGetDashboardRequest {
    const rememberMeControlValue =
      this.setRememberMeValue(userInputFields) || 'N';
    const persistentLogin = this.setPersistentLoginValue(userInputFields);
    const refreshURL = this.getRefreshUrl(standalonePage);
    const appValue = this.getAppValue(standalonePage, fromApp);

    const baseRequest = {
      formNameSubmitted: 'login',
      persistentLogin,
      refreshURL,
      rememberMe: rememberMeControlValue,
      ...(appValue && { fromApp: appValue })
    };

    return tokenHeader
      ? baseRequest
      : { ...baseRequest, eamToken: access_token };
  }

  private getAppValue(
    standalonePage: boolean,
    fromApp: string
  ): string | undefined {
    return this.fromAppCheck(standalonePage, fromApp)
      ? this.getFromApp(standalonePage)
      : fromApp;
  }

  getRefreshUrl(standalonePage: boolean): string | null {
    let refreshUrl: string | null;
    if (!standalonePage) {
      refreshUrl = this.pingAdapter.redirectUrl
        ? `${window.location.origin}${this.pingAdapter.redirectUrl}`
        : window.location.href;
    } else {
      refreshUrl = this.checkActivatedRoute();
    }
    return refreshUrl !== 'null' ? refreshUrl : null;
  }

  checkActivatedRoute() {
    if (this.hasRedirectBack()) {
      return document.referrer;
    }
    if (this.hasRefreshUrl()) {
      return this.getRefreshUrlWithParamsSafe();
    }
    return this.actiavtedRoute.snapshot.queryParamMap.get(BAU_REFRESH_URL);
  }

  private hasRedirectBack(): boolean {
    return !!this.actiavtedRoute.snapshot.queryParamMap.get(REDIRECT_BACK);
  }

  private hasRefreshUrl(): boolean {
    return !!this.actiavtedRoute.snapshot.queryParamMap.get(REFRESH_URL);
  }

  private getRefreshUrlWithParamsSafe(): string | null {
    try {
      return this.getRefreshUrlWithParamsPreserved(
        this.actiavtedRoute.snapshot.queryParamMap.get(REFRESH_URL)
      );
    } catch {
      return this.actiavtedRoute.snapshot.queryParamMap.get(REFRESH_URL);
    }
  }

  vsRefreshUrl(standalonePage: boolean): string | null {
    if (this.getRefreshUrl(standalonePage) === 'null') {
      return null;
    } else {
      return this.getRefreshUrl(standalonePage);
    }
  }

  getLoginCustomerRequest(
    userInputFields: LoginAuthUserInputFields | undefined,
    queryParam: string,
    standalonePage = false
  ): loginCustomerRequest {
    const encryptedObject: encryptedFields = {
      encryptedUsername: this.utilHelper.loginCustTransform(
        queryParam,
        ENCRYPTED_FIELDS.LOGIN_USERNAME
      ),
      encryptedPassword: this.utilHelper.loginCustTransform(
        queryParam,
        ENCRYPTED_FIELDS.LOGIN_PASSWORD
      ),
      encryptedLastname: this.utilHelper.loginCustTransform(
        queryParam,
        ENCRYPTED_FIELDS.LOGIN_LAST_NAME
      ),
      encryptedTokenId: this.utilHelper.loginCustTransform(
        queryParam,
        ENCRYPTED_FIELDS.LOGIN_TOKEN_ID
      )
    };
    let requestObject: loginCustomerRequest;
    requestObject = {
      formNameSubmitted: 'login',
      persistentLogin: 'N', //TODO: check with bff if sending Y does anything
      refreshURL: this.vsRefreshUrl(standalonePage), //TODO: should we get the refresh url from queryParams - probably not
      rememberMe: userInputFields?.persistentLogin,
      [encryptedObject.encryptedUsername]: userInputFields?.userName,
      [encryptedObject.encryptedPassword]: userInputFields?.password,
      [encryptedObject.encryptedLastname]: userInputFields?.lastName
        ? userInputFields?.lastName
        : '',
      tokenId: encryptedObject.encryptedTokenId
    };
    requestObject = {
      ...requestObject
      // fromApp: 'login'
    };
    return requestObject;
  }
}
